import { createRouter, createWebHashHistory } from 'vue-router'
import AIDisclosure from '@/presentation/pages/ai-disclosure/AIDisclosure.vue'
import { loadI18n } from '@/infrastructure/locales'

const router = createRouter({
    history: createWebHashHistory(),
    routes: [
        {
            path: '/',
            redirect: '/disclosure/new',
            beforeEnter: async(to, from, next) => {
                await loadI18n()
                next()
            },
            children: [
                {
                    path: '/disclosure/:taskId',
                    name: 'ai-disclosure',
                    component: AIDisclosure,
                }
            ],
        }
    ],
})

export default router
